import React from 'react';
import { Box, Text, Image, ResponsiveContext } from 'grommet';

const Lede = ({ text, imageUrl, children }) => {
  const size = React.useContext(ResponsiveContext);

  return (
    <Box
      width="medium"
      alignSelf="center"
      pad="medium"
      border={{
        color: 'accent-1',
        size: 'medium',
        side: 'left'
      }}
      margin={{
        top: 'large',
        bottom: 'large',
        left: size === 'small' || size === 'medium' ? 'large' : 'medium'
      }}
    >
      {imageUrl && <Image src={imageUrl} fit="cover" />}
      <Text size="large">{text}</Text>
      {children}
    </Box>
  );
};

export default Lede;
